//first thing first, we set body display none without delay
//document.body.classList.add('atac_loading');

if (!Date.now) {
    Date.now = function () {
        return new Date().getTime();
    };
}

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}

var atac_page_settings = {
    security: {
        domain: 'ENV.auth0:Domain',
        clientID: 'ENV.auth0:ClientId',
        LogOut: 'ENV.accounts:SSOLogOutURL',
        loginUrl: "/",
        bearerToken: function () {
            try {
                return CookiesHelper.readCookieValue("__PortalAuthCookie", "id_token");
            } catch (e) {
                return "";
            }
        },
        accessToken: function () {
            try {
                return CookiesHelper.readCookieValue("__PortalAuthCookie", "access_token");
            } catch (e) {
                return "";
            }
        }
    },
    cdn_root: "http://localhost:10606/dist/",
    showLeftMenu: true,
    showMessages: true,
    showUserWidget: true,
    showApplicationMenu: true,

    showDropdownFilterBox: false,
    showSiteFilterBox: false,
    


    script_timeout: 400,
    script_max_attempts: 10,
    scroll_timeout: 200,
    scroll_threshold_px: 100,
    mobile_breakpoint_width: 900,
    is_mobile: function () {
        var mql = window.matchMedia("screen and (min-width: " + this.mobile_breakpoint_width + "px)");
        return !mql.matches;
    }
};

var application_metadata = {
    system_name: "",
    system_name_sub: "",
    system_name_logo: ""
};

//We use the utils object to manage some helper methods we might need
//the base is basically code from underscore (or lodash) but we wrap it in the utils namespace to avoid potential
//clashing

var utils = function (obj) {
    if (obj instanceof utils) return obj;
    if (!(this instanceof utils)) return new utils(obj);
    this._wrapped = obj;
};

utils.now = Date.now || function () {
    return new Date().getTime();
};

utils.throttle = function (func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function () {
        previous = options.leading === false ? 0 : utils.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    return function () {
        var now = utils.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
};

Array.prototype.ATAC_Filter = function (key, value) {
    var res = this.filter(function (x) { return x[key] === value; });
    return (res && res.length > 0) ? res[0] : null;
};


/***********************************************/
/* MANAGE OUR EXTERNAL DEPENDANCIES (DOWNLOAD & INCLUDE) */
/***********************************************/
var DependancyManager = function () {
    var script_list = [
		{
		    name: "jquery",
		    test: function () {
		        return (typeof jQuery !== 'undefined');
		    },
		    path: "https://ajax.googleapis.com/ajax/libs/jquery/2.2.0/jquery.min.js"
		},
		{
		    name: "bootstrap",
		    test: function () {
		        return (typeof ($.fn.popover) !== 'undefined');
		    },
		    path: "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/js/bootstrap.min.js"
		},
        {
            name: "underscore",
            test: function () {
                return (typeof (_) !== 'undefined');
            },
            path: "https://cdnjs.cloudflare.com/ajax/libs/underscore.js/1.8.3/underscore-min.js"
        },
        {
            name: "moment",
            test: function () {
                return (typeof (moment) !== 'undefined');
            },
            path: "https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.11.2/moment.min.js"
        },
        { 
            name: "typekit",
            test: function () {
                return (typeof (Typekit) !== 'undefined');
            },
            path: "https://use.typekit.net/odp7bst.js"
        }
    ];

    var css_list = [
        atac_page_settings.cdn_root + "styles/styles.css?v=" + Date.now(),
		"https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css",
        "https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.3/css/select2.min.css"
    ];

    this.checkCss = function () {

        $.each(css_list, function (i, o) {
            var style = document.createElement('link');
            style.type = "text/css";
            style.rel = "stylesheet";
            style.href = o;
            document.getElementsByTagName('head')[0].appendChild(style);
        });

    };

    this.checkScript = function (name, success, error) {
        var attempts = 0;
        var max_attempts = atac_page_settings.script_max_attempts;
        var timeout = atac_page_settings.script_timeout;


        var script_info = script_list.ATAC_Filter("name", name);

        if (!script_info) {
            if (error)
                error('Could not find jquery script reference');
            return;
        }

        if (!script_info.test()) {
            var script = document.createElement('script');
            script.type = "text/javascript";
            script.src = script_info.path;
            document.getElementsByTagName('head')[0].appendChild(script);
        } else {
            if (success)
                success();
            return;
        }

        var check = setInterval(function () {
            attempts++;
            if (attempts > max_attempts) {
                if (error)
                    error(name + ' loading timed out');
            }

            if (script_info.test()) {
                clearInterval(check);

                if (success)
                    success();
            }
        }, timeout);
    };

    return this;
};

/***********************************************/
/* CONTROL AND HELP WITH OUR USER DETAILS */
/***********************************************/
var UserController = function (user) {

    var resolveFullName = function () {
        user.full_name = function () {
            return user.nickname;
        };
    };

    var resolveProfileImage = function () {
        if (!user)
            throw "User Object Not Defined!";

        user.profile_image = function () {
            var has_profile_url = /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(user.picture);
            if (!has_profile_url) {
                return ((user.given_name ? user.given_name.charAt(0) : "") + (user.family_name ? user.family_name.charAt(0) : "")).toUpperCase();
            } else {
                return $("<img>").attr("src", user.picture)[0].outerHTML;
            }
            return null;
        };
    };

    resolveFullName();
    resolveProfileImage();
};

var HTMLFactory = function () {

    this.GetHTMLByTemplateName = function (name, obj) {
        var template = _.template(atac_templates[name]);
        return template(obj);
    };

    return this;
};

var Portal = function () {
    var $app = null;
    var portal = this;
    var htmlFactory = new HTMLFactory();
    var loader;
    var dependancyManager = new DependancyManager();

    /***********************************************/
    /* PRIVATE FUNCTIONS */
    /***********************************************/
    function init() {
        if (typeof atac_settings !== typeof undefined) {
            atac_page_settings = $.extend(atac_page_settings, atac_settings);
        }

        function preInit(callback) {
            var scriptLoadFailed = function (msg) {
                alert(msg);
            };

            var loadUnderscore = function () {
                dependancyManager.checkScript("underscore", loadMoment, scriptLoadFailed);
            };

            var loadMoment = function () {
                dependancyManager.checkScript("moment", callback, scriptLoadFailed);
            };

            dependancyManager.checkScript("jquery", loadUnderscore, scriptLoadFailed);

            dependancyManager.checkScript("multiSelect");
            dependancyManager.checkScript("bSelect");

        }

        preInit(function () {
            loadSecurity();
            extractMetaData();
            scaffold();
            bindEvents();
            wireMenu();
            writeGlobalSearch();
            try {
                loadUserDetails();
            } catch (ex) {
                console.error(ex);
            }

        });
    }

    function loadSecurity() {
        console.log('load security');

        portal.auth0 = new auth0.WebAuth({
            domain: atac_page_settings.security.domain,
            clientID: atac_page_settings.security.clientID,
            loginUrl: atac_page_settings.security.loginUrl
        });

        (function (open) {
            XMLHttpRequest.prototype.open = function () {
                //need to save the URL so we can access it in the send method
                this._url = arguments[1];
                open.apply(this, arguments);
                //open.call(this, METHOD, URL, ASYNC, USER, PASSWORD);
            };
        })(XMLHttpRequest.prototype.open);

        (function (send) {
            XMLHttpRequest.prototype.send = function (data) {

                //validate the JWT token exists and is still valid
                if (!!atac_page_settings.security.bearerToken()) {
                    var decoded = jwt_decode(atac_page_settings.security.bearerToken());
                    var currentTime = moment();
                    //reject Auth cookie that only has 10 seconds left so we dont get into a race condition
                    //Token is valid on request but invalid when it gets processed on the server.
                    var expiryTime = moment(decoded.exp * 1000).subtract(10, 'seconds');
                    if (currentTime.isAfter(expiryTime)) {
                        //if the JWT has expired we cant authenticate, so reload
                        location.reload(true);
                        return;
                    }
                    //solutions uses portal.js without being authenticated so we cant reload the page if the token is not present
                    //} else {
                    //    //the bearer token is missing, that means the we cant authenticate API requests. reload to force relogin 
                    //    location.reload(true);
                }

                //injecting the JWT Token set by Auth0 (eg. accessToken) in the request headers before the request gets sent
                if ((this._url.startsWith('/') ||
                    this._url.indexOf('autocartruck.org') !== -1 ||
                    this._url.indexOf('autocartruck.com') !== -1) &&
                    atac_page_settings.security.bearerToken() &&
                    this._url.indexOf('cdn') === -1) {
                    this.setRequestHeader('Authorization', 'Bearer ' + atac_page_settings.security.bearerToken());
                }

                send.apply(this, arguments);
            };
        })(XMLHttpRequest.prototype.send);

        //we need to refresh the JWT Token every 15 minutes
        //this will make sure that the user never gets logged out while on a page
        (function pollIDIDToken() {
            function setIDTokenRenewalTimeout() {
                if (!!atac_page_settings.security.bearerToken()){
                    var decoded = jwt_decode(atac_page_settings.security.bearerToken());
                    var currentTime = moment();
                    //JWT Token will Expire in 8 hours from login
                    //MVC's Auth cookie has a sliding expiration but is session based
                    //due to this we don't know when the __PortalAuthCookie will expire
                    //the __PortalAuthCookie is set to be Session based now we will use 
                    //the front end to manage the JWT Token
                    var expiryTime = moment(decoded.exp * 1000).subtract(1, 'minutes');
                    setTimeout(function () {
                        renewIDToken();
                    }, expiryTime.diff(currentTime)); //set to token Expiry Minus 5 minutes 
                }
            }

            function renewIDToken() {

                if (!!atac_page_settings.security.bearerToken()) {
                    portal.auth0.checkSession({
                        responseType: 'token id_token',
                        scope: 'openid email nickname name username roles psid',
                        redirectUri: window.location.origin
                    }, function (err, delegationResult) {

                        console.log('checkSession Inside');

                        // err if automatic parseHash fails
                        if (err) {
                            location.reload(true);
                            throw err;
                        }
                        console.log(delegationResult);
                        CookiesHelper.updateCookieValue("__PortalAuthCookie", "id_token", delegationResult.idToken, 0, 0);
                        CookiesHelper.updateCookieValue("__PortalAuthCookie", "access_token", delegationResult.accessToken, 0, 0);
                        setIDTokenRenewalTimeout();

                    });

                    //portal.auth0.renewIdToken(atac_page_settings.security.bearerToken(),
                    //    function(err, delegationResult) {
                    //        //need to resave the cookie.
                    //        if (err){
                    //            location.reload(true);
                    //            throw err;
                    //        }

                    //        CookiesHelper.updateCookieValue("__PortalAuthCookie", "id_token", delegationResult.id_token, 0, 0);
                    //        setIDTokenRenewalTimeout();
                    //    });
                } else{
                    location.reload(true);
                }
            }

            setIDTokenRenewalTimeout();
        })();
    }

    function extractMetaData() {
        $("meta[role=application]").each(function (meta) {
            application_metadata[$(this).attr('name')] = $(this).attr('content');
        });
    }

    function scaffold() {
        $app = $("#atac_application");
        //console.log('settings used: ', atac_page_settings);

        // build the main menu
        $("#atac_top-menu").append(htmlFactory.GetHTMLByTemplateName("top_menu", application_metadata));

     

        // build the top menu
        if (atac_page_settings.showLeftMenu)
            $("#atac_main-menu").append(htmlFactory.GetHTMLByTemplateName("main_menu"));
        else {
            $("#atac_main-menu").remove();
            $app.removeClass('show-nav');
        }

        // append main messages
        $app.append(htmlFactory.GetHTMLByTemplateName("main_messages"));

        // append the loader
        $app.append(htmlFactory.GetHTMLByTemplateName("loader"));
        portal.hideLoader();

        // append the loader
        //$("#atac_main-menu").append(htmlFactory.GetHTMLByTemplateName("footer"));

        checkUserSettings();
    }

    function checkUserSettings() {
        if (!atac_page_settings.showLeftMenu) {
            $("#atac_menu_left").remove();
            $("#atac_application").addClass('no-nav');
        }

        if (!atac_page_settings.showApplicationMenu) {
            $("#atac_menu_right").remove();
            $("#atac_application").addClass('no-app-messages');
        }

        if (!atac_page_settings.showUserWidget) {
            $("#atac_user_widget").html('');
            $("#atac_application").addClass('no-user-widget');
        }
    }

    function wireMenu() {
        if (!atac_page_settings.showLeftMenu)
            return;

        $("nav#main-nav > ul > li > ul").each(function (i, o) {
            var $el = $(this);

            var $parent = $el.parent("li");
            var $anchor = $parent.find("> a");
            var $toggle = $("<span>").attr('class', 'indicator');

            $anchor.append($toggle);

            $anchor.bind('click', function (evt) {
                $parent.toggleClass('expanded');
                evt.preventDefault();
                evt.stopPropagation();
                return false;
            });
        });

        //check if we want to show the menu
        if (atac_page_settings.is_mobile()) {
            $app.removeClass('show-nav');
        }
    }

    function writeGlobalSearch() {
        portal.globalSearch = globalSearch;
        globalSearch.render();
    }

    //LOAD TEMPLATE MARKUP
    function populateUserDetails() {
        if (!user_object.user)
            throw "Could Not Find User Object";

        var userController = new UserController(user_object.user);

        var $menu = $("#atac_system_dropdown").html('');
        var $user = $("#atac_user_widget").html('');
        var $message = $("#atac_message_holder").html('');



        var populateMenuWidget = function () {
            //populate the system menu
            if (!user_object.user.app_metadata && !user_object.user.app_metadata.Applications) {
                //throw "No app metadata specified for this user!";
                return;
            }

            _.each(_.sortBy(user_object.user.app_metadata.Applications, function (o) { return o.Description; }), function (i, o, v) {
                console.log('populate menu widgt', i, o); 
                if (i.Type === "Site") {
	                $menu.append(htmlFactory.GetHTMLByTemplateName("system_menu_item", { settings: atac_page_settings, obj: i }));
                }
            });

            $menu.find(".atac-system-menu-item a").click(function (e) {
                e.stopPropagation();
            });
        };

        var populateUserWidget = function () {
            $user.append(htmlFactory.GetHTMLByTemplateName("user_widget", user_object));
        };

        var logOutClick = function () {
            $("#atac_system_logoff").on("click", function () {
                //create return URL. origin is not defined in some browsers
                if (typeof location.origin === 'undefined')
                    location.origin = location.protocol + '//' + location.host;

                var baseURL = atac_page_settings.security.LogOut;
                //if we are local just log us out of the current application
                if (location.origin.indexOf('local'.toLowerCase()) !== -1) {
                    baseURL = '/security/logout';
                }
                //add the return URL to the log out URL
                var logOutUrl = baseURL + '?returnURL=' + encodeURIComponent(location.origin);
                //The user can sometimes be logged out of SSO before we log him out
                //so we need to add the user ID here
                if (!!user_object.user) {
                    //debugger;
                    var id = user_object.user.user_id;
                    var userId = id.startsWith("auth0|") ? id : id.split('|').pop();
                    logOutUrl = logOutUrl + '&userID=' + encodeURIComponent(userId);

                }


                window.location.replace(logOutUrl);
            });
        };

        var populateMessage = function (message) {
            return htmlFactory.GetHTMLByTemplateName("message_item", message);
        };

        var populateMessageWidget = function () {
            var widget_data = _.extend(user_object, {
                renderMessage: populateMessage
            });
            $message.append(htmlFactory.GetHTMLByTemplateName("message_widget", widget_data));
        };

        if (atac_page_settings.showLeftMenu)
            populateMenuWidget();

        if (atac_page_settings.showUserWidget)
            populateUserWidget();

        if (atac_page_settings.showUserWidget)
            populateMessageWidget();

        if (atac_page_settings.showUserWidget)
            logOutClick();

        if (atac_page_settings.pageUserWidgetElementID) {
            $user.html($(atac_page_settings.pageUserWidgetElementID));
        }
    }

    function loadUserDetails() {
        var detailsLoaded = function () {
            populateUserDetails();
        };

        var detailsFailed = function () {
            alert('There was a problem loading your details, please refresh and try again.');
        };

        if (!!atac_page_settings.security.bearerToken()) {
            portal.getUserProfile("portal", function (err, data) {
                //set the user object
                if (err)
                    throw err;

                //user Bearer token is not set
                if (data === "Bearer Token not set") {
                    //console.log("Bearer Token not set");
                    return;
                }

                user_object.user = data;
                //console.log(user_object);
                detailsLoaded();
            });
        } else {
            //user is not logged in get rid of the right menu
            $("#atac_menu_right").remove();
        }


    }

    //EVENTS
    function bindEvents() {
        var bindMenuButton = function () {
            var $el = $(".btn-toggle-menu").unbind('click').bind('click', onToggleMenu);
        };

        var bindMessageButton = function () {
            //TODO: Put this back once messages work again...
            //var $el = $(".btn-toggle-messages").unbind('click').bind('click', onToggleMessages);
        };

        var bindWindowScoll = function () {
            $(window).bind('scroll', utils.throttle(onWindowScroll, atac_page_settings.scroll_timeout));
        };


        bindMenuButton();
        bindMessageButton();
        bindWindowScoll();
    }

    function onToggleMenu() {
        if (atac_page_settings.is_mobile()) {
            $app.removeClass('show-messages');
        }
        $app.toggleClass('show-nav');
    }

    function onToggleMessages() {
        if (atac_page_settings.is_mobile()) {
            $app.removeClass('show-nav');
        }
        $app.toggleClass('show-messages');
    }

    function onWindowScroll() {
        var scrollTop = $(window).scrollTop();

        if (scrollTop > atac_page_settings.scroll_threshold_px) {
            $app.addClass('scrolling');
        } else {
            $app.removeClass('scrolling');
        }
    }

    /***********************************************/
    /* PUBLIC FUNCTIONS */
    /***********************************************/
    portal.showLoader = function (immediate) {
        if (immediate) {
            $("#atac_application-overlay").show();
            $("#atac_page-loader").show();
        } else {
            $("#atac_application-overlay").fadeIn();
            $("#atac_page-loader").fadeIn();
        }
    };

    portal.getUserProfile = function (application, callback) {
        try {
            if (!!atac_page_settings.security.bearerToken()) {
                //var decoded = jwt_decode(atac_page_settings.security.bearerToken());
                //    if (callback)
                //        callback(null, decoded);
                portal.auth0.client.userInfo(atac_page_settings.security.accessToken(), function (err, data) {
                    if (callback)
                        callback(err, data);
                });
            } else {
                if (callback)
                    callback(null, "Bearer Token not set");
            }
        } catch (ex) {
            if (callback)
                callback(ex, null);
        }

    };

    portal.hideLoader = function (immediate) {
        if (immediate) {
            $("#atac_application-overlay").hide();
            $("#atac_page-loader").hide();
        } else {
            $("#atac_application-overlay").fadeOut();
            $("#atac_page-loader").fadeOut();
        }
    };

    portal.htmlFactory = htmlFactory;

    ////this is the event from customer portal
    //portal.subscribeToGlobalFilter = function(callback) {
    //    //call method from site filter - 
    //};

    

   

    // Initialize the class
    init();

    return this;
};

window.ATAC = new Portal();


